import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

const EditProfile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    addressLine1: "",
    district: "",
    mlaConstituency: "",
    mpConstituency: "",
    pincode: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await API.get("/dashboard/profile");
        const user = res.data.user;
        setFormData({
          name: user.name || "",
          email: user.email || "",
          addressLine1: user.permanentAddress?.addressLine1 || "",
          district: user.permanentAddress?.district || "",
          mlaConstituency: user.permanentAddress?.mlaConstituency || "",
          mpConstituency: user.permanentAddress?.mpConstituency || "",
          pincode: user.permanentAddress?.pincode || "",
        });
      } catch (err) {
        toast.error("Failed to load profile");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.put("/dashboard/profile/update", formData);
      toast.success("Profile updated successfully!");
      navigate("/voter-dashboard");
    } catch (err) {
      toast.error("Update failed. Try again.");
    }
  };

  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-green-50 flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white shadow-lg rounded-xl p-8">
        <h2 className="text-3xl font-bold text-center text-orange-600 mb-6">
          ✍️ Edit Your Profile
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-orange-400"
            placeholder="Full Name"
            required
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-orange-400"
            placeholder="Email Address"
          />
          <input
            type="text"
            name="addressLine1"
            value={formData.addressLine1}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
            placeholder="Address"
            required
          />
          <input
            type="text"
            name="district"
            value={formData.district}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
            placeholder="District"
            required
          />
          <input
            type="text"
            name="mlaConstituency"
            value={formData.mlaConstituency}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
            placeholder="MLA Constituency"
            required
          />
          <input
            type="text"
            name="mpConstituency"
            value={formData.mpConstituency}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
            placeholder="MP Constituency"
            required
          />
          <input
            type="text"
            name="pincode"
            value={formData.pincode}
            onChange={handleChange}
            className="w-full p-3 border rounded-lg"
            placeholder="Pincode"
            maxLength={6}
            required
          />
          <button
            type="submit"
            className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700"
          >
            ✅ Save Changes
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
